import axios from 'axios';

export class SearchService {
  static async search(query: string, showAll = true, showTeam = true): Promise<any> {
    const { data }: { data: any } = await axios.get(
      `/get/search?query=${query}&showall=${showAll}&showteam=${showTeam}`
    );
    return data;
  }
}
